"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _LogisticTaskStatusComponent.default;
  }
});

var _LogisticTaskStatusComponent = _interopRequireDefault(require("./LogisticTaskStatus-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }